export default __webpack_public_path__ + "static/media/gray-down.649ea35b.svg";